"use strict";
var $a5fd07fa01589658$exports = {};
"use strict";
class $a5fd07fa01589658$var$Game {
    constructor(initialState){
        this.initialState = initialState;
        this.board = initialState || this.#createEmptyBoard();
        this.score = 0;
        this.status = "idle";
    }
    #createEmptyBoard() {
        return Array.from({
            length: 4
        }, ()=>Array(4).fill(0));
    }
    #generateSquare() {
        const emptyCells = [];
        for(let r = 0; r < 4; r++){
            for(let c = 0; c < 4; c++)if (this.board[r][c] === 0) emptyCells.push({
                row: r,
                col: c
            });
        }
        if (emptyCells.length > 0) {
            const { row: row, col: col } = emptyCells[Math.floor(Math.random() * emptyCells.length)];
            const value = Math.random() < 0.1 ? 4 : 2;
            this.board[row][col] = value;
        }
    }
    #isWin() {
        for(let r = 0; r < 4; r++)for(let c = 0; c < 4; c++){
            if (this.board[r][c] === 2048) return true;
        }
        return false;
    }
    #isGameOver() {
        for(let r = 0; r < 4; r++)for(let c = 0; c < 4; c++){
            if (this.board[r][c] === 0) return false;
        }
        for(let r = 0; r < 4; r++)for(let c = 0; c < 4; c++){
            const val = this.board[r][c];
            if (c < 3 && this.board[r][c + 1] === val) return false;
            if (r < 3 && this.board[r + 1][c] === val) return false;
        }
        return true;
    }
    #move(direction) {
        if (this.status !== "playing") return false;
        const previousBoard = JSON.parse(JSON.stringify(this.board));
        let moved = false;
        for(let i = 0; i < 4; i++){
            let rowOrCol = [];
            if (direction === "up") for(let j = 0; j < 4; j++)rowOrCol.push(this.board[j][i]);
            else if (direction === "down") for(let j = 0; j < 4; j++)rowOrCol.push(this.board[3 - j][i]);
            else if (direction === "left") rowOrCol = this.board[i];
            else if (direction === "right") rowOrCol = [
                ...this.board[i]
            ].reverse();
            const newRowOrCol = rowOrCol.filter((val)=>val !== 0);
            for(let j = 0; j < newRowOrCol.length - 1; j++)if (newRowOrCol[j] === newRowOrCol[j + 1]) {
                newRowOrCol[j] *= 2;
                this.score += newRowOrCol[j];
                newRowOrCol.splice(j + 1, 1);
            }
            while(newRowOrCol.length < 4)newRowOrCol.push(0);
            if (direction === "up") for(let j = 0; j < 4; j++)this.board[j][i] = newRowOrCol[j];
            else if (direction === "down") for(let j = 0; j < 4; j++)this.board[3 - j][i] = newRowOrCol[j];
            else if (direction === "left") this.board[i] = newRowOrCol;
            else if (direction === "right") this.board[i] = newRowOrCol.reverse();
        }
        if (JSON.stringify(this.board) !== JSON.stringify(previousBoard)) {
            this.#generateSquare();
            moved = true;
        }
        this.checkStatus();
        return moved;
    }
    moveLeft() {
        this.#move("left");
    }
    moveRight() {
        this.#move("right");
    }
    moveUp() {
        this.#move("up");
    }
    moveDown() {
        this.#move("down");
    }
    getScore() {
        return this.score;
    }
    getState() {
        return this.board;
    }
    getStatus() {
        return this.status;
    }
    start() {
        this.board = this.#createEmptyBoard();
        this.score = 0;
        this.status = "playing";
        this.#generateSquare();
        this.#generateSquare();
    }
    restart() {
        this.start();
    }
    checkStatus() {
        if (this.#isWin()) this.status = "win";
        else if (this.#isGameOver()) this.status = "lose";
    }
}
$a5fd07fa01589658$exports = $a5fd07fa01589658$var$Game;


const $09e991522ca7e64e$var$game = new $a5fd07fa01589658$exports();
const $09e991522ca7e64e$var$gameScoreText = document.querySelector(".game-score");
const $09e991522ca7e64e$var$startButton = document.querySelector(".button.start");
const $09e991522ca7e64e$var$gameField = document.querySelector(".game-field tbody");
const $09e991522ca7e64e$var$loseMessage = document.querySelector(".message-lose");
const $09e991522ca7e64e$var$winMessage = document.querySelector(".message-win");
const $09e991522ca7e64e$var$startMessage = document.querySelector(".message-start");
const $09e991522ca7e64e$var$arrowLeftButton = document.querySelector("#arrow-left");
const $09e991522ca7e64e$var$arrowUpButton = document.querySelector("#arrow-up");
const $09e991522ca7e64e$var$arrowRightButton = document.querySelector("#arrow-right");
const $09e991522ca7e64e$var$arrowDownButton = document.querySelector("#arrow-down");
const $09e991522ca7e64e$var$updateUI = ()=>{
    const board = $09e991522ca7e64e$var$game.getState();
    const cells = $09e991522ca7e64e$var$gameField.querySelectorAll(".field-cell");
    cells.forEach((cell)=>{
        cell.textContent = "";
        cell.className = "field-cell";
    });
    for(let r = 0; r < 4; r++)for(let c = 0; c < 4; c++){
        const value = board[r][c];
        const cell = cells[r * 4 + c];
        if (value !== 0) {
            cell.textContent = value;
            cell.classList.add(`field-cell--${value}`);
        }
    }
    $09e991522ca7e64e$var$gameScoreText.textContent = $09e991522ca7e64e$var$game.getScore();
    const gameStatus = $09e991522ca7e64e$var$game.getStatus();
    $09e991522ca7e64e$var$winMessage.classList.add("hidden");
    $09e991522ca7e64e$var$loseMessage.classList.add("hidden");
    $09e991522ca7e64e$var$startMessage.classList.add("hidden");
    if (gameStatus === "win") $09e991522ca7e64e$var$winMessage.classList.remove("hidden");
    else if (gameStatus === "lose") $09e991522ca7e64e$var$loseMessage.classList.remove("hidden");
    if (gameStatus === "idle") {
        $09e991522ca7e64e$var$startMessage.classList.remove("hidden");
        $09e991522ca7e64e$var$startButton.textContent = "Start";
        $09e991522ca7e64e$var$startButton.classList.remove("restart");
        $09e991522ca7e64e$var$startButton.classList.add("start");
    } else {
        $09e991522ca7e64e$var$startButton.textContent = "Restart";
        $09e991522ca7e64e$var$startButton.classList.remove("start");
        $09e991522ca7e64e$var$startButton.classList.add("restart");
    }
    const isPlaying = gameStatus === "playing";
    $09e991522ca7e64e$var$arrowUpButton.disabled = !isPlaying;
    $09e991522ca7e64e$var$arrowDownButton.disabled = !isPlaying;
    $09e991522ca7e64e$var$arrowLeftButton.disabled = !isPlaying;
    $09e991522ca7e64e$var$arrowRightButton.disabled = !isPlaying;
};
const $09e991522ca7e64e$var$handleMove = (e)=>{
    if ($09e991522ca7e64e$var$game.getStatus() === "playing") {
        switch(e.key){
            case "ArrowUp":
                $09e991522ca7e64e$var$game.moveUp();
                break;
            case "ArrowDown":
                $09e991522ca7e64e$var$game.moveDown();
                break;
            case "ArrowLeft":
                $09e991522ca7e64e$var$game.moveLeft();
                break;
            case "ArrowRight":
                $09e991522ca7e64e$var$game.moveRight();
                break;
        }
        $09e991522ca7e64e$var$updateUI();
    }
};
document.addEventListener("DOMContentLoaded", ()=>{
    $09e991522ca7e64e$var$updateUI();
});
$09e991522ca7e64e$var$startButton.addEventListener("click", ()=>{
    $09e991522ca7e64e$var$game.restart();
    $09e991522ca7e64e$var$updateUI();
});
document.addEventListener("keydown", $09e991522ca7e64e$var$handleMove);
$09e991522ca7e64e$var$arrowUpButton.addEventListener("click", ()=>{
    if ($09e991522ca7e64e$var$game.getStatus() === "playing") {
        $09e991522ca7e64e$var$game.moveUp();
        $09e991522ca7e64e$var$updateUI();
    }
});
$09e991522ca7e64e$var$arrowDownButton.addEventListener("click", ()=>{
    if ($09e991522ca7e64e$var$game.getStatus() === "playing") {
        $09e991522ca7e64e$var$game.moveDown();
        $09e991522ca7e64e$var$updateUI();
    }
});
$09e991522ca7e64e$var$arrowLeftButton.addEventListener("click", ()=>{
    if ($09e991522ca7e64e$var$game.getStatus() === "playing") {
        $09e991522ca7e64e$var$game.moveLeft();
        $09e991522ca7e64e$var$updateUI();
    }
});
$09e991522ca7e64e$var$arrowRightButton.addEventListener("click", ()=>{
    if ($09e991522ca7e64e$var$game.getStatus() === "playing") {
        $09e991522ca7e64e$var$game.moveRight();
        $09e991522ca7e64e$var$updateUI();
    }
});


//# sourceMappingURL=index.4f0f531f.js.map
